export default {
  title: 'Ontwikkelaars',
  subtitle: 'API-sleutels, webhooks en leveringsgeschiedenis voor je Partner API-integratie.',
  no_account: 'Nog geen Partner API-account — neem contact op met Foodamigos om er een aan te vragen.',
  no_account_manage: 'Nog geen Partner API-account — maak er een aan om sleutels uit te geven.',
  buttons: {
    new_account: 'Nieuw account',
    edit_account: 'Account bewerken',
    docs: 'API-documentatie',
  },
  tabs: {
    api_keys: 'API-sleutels',
    webhooks: 'Webhooks',
    deliveries: 'Leveringen',
  },
  toasts: {
    load_error: 'Kan je Partner API-accounts niet laden.',
  },
};
